var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "129px",
    height: "129px",
    viewBox: "0 0 129 129",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Alert/Orange") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Alert/Orange",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#F5A623",
    id: "Icon/Material-Design/Alert---Orange"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58,83 L71,83 L71,96 L58,96 L58,83 Z M58,32 L71,32 L71,71 L58,71 L58,32 Z M64.4355,0 C28.8315,0 0,28.896 0,64.5 C0,100.104 28.8315,129 64.4355,129 C100.104,129 129,100.104 129,64.5 C129,28.896 100.104,0 64.4355,0 L64.4355,0 Z M64.5,116 C36.04625,116 13,92.95375 13,64.5 C13,36.04625 36.04625,13 64.5,13 C92.95375,13 116,36.04625 116,64.5 C116,92.95375 92.95375,116 64.5,116 L64.5,116 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrange);
export default __webpack_public_path__ + "static/media/Orange.3d8a3aca5a1f1f26f2197ffb5d6f0113.svg";
export { ForwardRef as ReactComponent };